import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Sidebar, TopBar } from './components/Navigation';
import Dashboard from './views/Dashboard';
import Vendors from './views/Vendors';
import Contracts from './views/Contracts';
import Approvals from './views/Approvals';
import Settings from './views/Settings';
import Guide from './views/Guide';
import './index.css';

function App() {
  return (
    <HashRouter>
      <div className="flex h-screen bg-[#0A0F1C] font-sans text-slate-200 overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col relative overflow-hidden">
          {/* Subtle background glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-yellow-500/5 blur-[120px] rounded-full pointer-events-none"></div>
          
          <TopBar />
          <main className="flex-1 overflow-y-auto relative z-10 custom-scrollbar pb-10">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/contracts" element={<Contracts />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/guide" element={<Guide />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </div>
    </HashRouter>
  );
}

export default App;